import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route } from 'react-router-dom';
import { CartProvider } from './lib/cart';
import { LanguageProvider } from './lib/language';
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailure from './pages/PaymentFailure';
import PaymentPending from './pages/PaymentPending';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import QAPage from './pages/QAPage';
import ProtectedRoute from './components/ProtectedRoute';
function App() {
    return (_jsx(LanguageProvider, { children: _jsx(CartProvider, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Home, {}) }), _jsx(Route, { path: "/faq", element: _jsx(QAPage, {}) }), _jsx(Route, { path: "/product/:slug", element: _jsx(ProductDetail, {}) }), _jsx(Route, { path: "/cart", element: _jsx(Cart, {}) }), _jsx(Route, { path: "/checkout", element: _jsx(Checkout, {}) }), _jsx(Route, { path: "/checkout/success", element: _jsx(PaymentSuccess, {}) }), _jsx(Route, { path: "/checkout/failure", element: _jsx(PaymentFailure, {}) }), _jsx(Route, { path: "/checkout/pending", element: _jsx(PaymentPending, {}) }), _jsx(Route, { path: "/admin/login", element: _jsx(AdminLogin, {}) }), _jsx(Route, { path: "/admin", element: _jsx(ProtectedRoute, { children: _jsx(AdminDashboard, {}) }) })] }) }) }));
}
export default App;
